import { useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { IonGrid, IonRow, IonCol, IonLabel, IonButton, IonIcon } from '@ionic/react';
import { swapVertical } from 'ionicons/icons';
import { Storage } from '@capacitor/storage';
import { CheckObject } from '../../defines/Functions';
import FlightAirport from './modals/FlightAirport';
import FlightHotelPassenger from './modals/FlightHotelPassenger';
import MyDatepicker from '../MyDatepicker';
interface Props {
    data?: any
}

const Flight = (props: Props) => {
    let flightHotelJson = {} as any;
    const [state, setState] = useState({
        flightHotelOriginValue: {} as any,
        flightHotelDestinationValue: {} as any,
        flightHotelPassengerValue: {
            rooms: [{
                adults: 2,
                childs: 0,
                childsAges: [] as any,
            }],
            cabinClass: "Economy",
        },
        datepickerValue: [] as any,
    })
    const [required, setRequired] = useState({
        origin: false,
        destination: false,
        date: false,
    });
    const handleOriginCallback = (childData: any) => {
        let childDataObj = JSON.parse(childData);
        setState({ ...state, flightHotelOriginValue: childDataObj });
        setRequired({ ...required, origin: false });
    }
    const handleDestinationCallback = (childData: any) => {
        let childDataObj = JSON.parse(childData);
        setState({ ...state, flightHotelDestinationValue: childDataObj });
        setRequired({ ...required, destination: false });
    }
    const handleDatepickerCallback = (childDataObj: any) => {
        setState({ ...state, datepickerValue: childDataObj });
        setRequired({ ...required, date: false });
    }
    const handlePassengerCallback = (childData: any) => {
        setState({ ...state, flightHotelPassengerValue: childData });
    }
    flightHotelJson = {
        rooms: state.flightHotelPassengerValue.rooms,
        other: {
            "cabin": state.flightHotelPassengerValue.cabinClass,
            "isJalali": state.datepickerValue.isJalali === 'true' ? true : false
        },
        from: state.flightHotelOriginValue,
        to: state.flightHotelDestinationValue,
        dates: {
            "departure": state.datepickerValue.dates ? state.datepickerValue.dates[0] : null,
            "arrival": state.datepickerValue.dates ? state.datepickerValue.dates[1] : null,
            "departureJalali": state.datepickerValue.dates ? state.datepickerValue.datesJalali[0] : null,
            "arrivalJalali": state.datepickerValue.dates ? state.datepickerValue.datesJalali[1] : null,
            "departureJalaliFormatted": state.datepickerValue.dates ? state.datepickerValue.datesJalaliFormatted[0] : null,
            "arrivalJalaliFormatted": state.datepickerValue.dates ? state.datepickerValue.datesJalaliFormatted[1] : null
        }
    }
    const setFlightHotelJson = async () => {
        await Storage.set({
            key: 'flightHotelJson',
            value: JSON.stringify(flightHotelJson),
        });
    };
    const clearFlightHotelJson = async () => {
        await Storage.remove({ key: 'flightHotelJson' });
    };
    const history = useHistory();
    const didGetFlightHotelJson = useRef(false);
    useEffect(() => {
        if (!didGetFlightHotelJson.current) {
            const getFlightHotelJson = async () => {
                const { value } = await Storage.get({ key: 'flightHotelJson' });
                if (value !== null) {
                    const objectValue = JSON.parse(value);
                    let datepickerValues = {
                        dates: [],
                        datesJalali: [],
                        datesJalaliFormatted: []
                    } as any;
                    datepickerValues.dates.push(objectValue.dates.departure);
                    datepickerValues.datesJalali.push(objectValue.dates.departureJalali);
                    datepickerValues.datesJalaliFormatted.push(objectValue.dates.departureJalaliFormatted);
                    datepickerValues.dates.push(objectValue.dates.arrival);
                    datepickerValues.datesJalali.push(objectValue.dates.arrivalJalali);
                    datepickerValues.datesJalaliFormatted.push(objectValue.dates.arrivalJalaliFormatted);
                    setState({
                        ...state,
                        flightHotelOriginValue: objectValue.from,
                        flightHotelDestinationValue: objectValue.to,
                        flightHotelPassengerValue: { rooms: objectValue.rooms, cabinClass: objectValue.other.cabin },
                        datepickerValue: datepickerValues,
                    });
                }
            };
            getFlightHotelJson();
            didGetFlightHotelJson.current = true;
        }
    }, [props, state]);
    const onSearchCLick = () => {
        let isRequired = false;
        if (CheckObject(state.flightHotelOriginValue)) {
            setRequired(prevRequired => { return { ...prevRequired, origin: true } });
            isRequired = true;
        }
        if (CheckObject(state.flightHotelDestinationValue)) {
            setRequired(prevRequired => { return { ...prevRequired, destination: true } });
            isRequired = true;
        }
        if (state.datepickerValue.length === 0) {
            setRequired(prevRequired => { return { ...prevRequired, date: true } });
            isRequired = true;
        }
        if (!isRequired) {
            clearFlightHotelJson();
            setFlightHotelJson();
            history.push({
                pathname: '/search/flightHotel'
            });
        }
    }
    const swapValue = () => {
        setState({
            ...state,
            flightHotelOriginValue: state.flightHotelDestinationValue,
            flightHotelDestinationValue: state.flightHotelOriginValue,
        });
    }
    return (
        <IonGrid>
            <IonRow>
                <IonCol size="12">
                    <div className="form-input-container">
                        <IonRow>
                            <IonCol size="12">
                                <IonLabel>
                                    مبدا پرواز
                                    {required.origin ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <FlightAirport type="origin" section="tour" flightAirportParentCallback={handleOriginCallback} itemValue={state.flightHotelOriginValue.title} />
                            </IonCol>
                            <IonCol size="12" className="destination-input">
                                <span className="source-destinatin-swap-btn" onClick={swapValue}>
                                    <IonIcon icon={swapVertical} />
                                </span>
                                <IonLabel>
                                    مقصد پرواز
                                    {required.destination ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <FlightAirport type="destination" section="tour" flightAirportParentCallback={handleDestinationCallback} itemValue={state.flightHotelDestinationValue.title} />
                            </IonCol>
                            <IonCol size="12">
                                <IonLabel>
                                    تاریخ رفت / برگشت
                                    {required.date ? <span className="required">الزامی</span> : null}
                                </IonLabel>
                                <MyDatepicker
                                    value={state.datepickerValue && state.datepickerValue.dates && [new Date(state.datepickerValue.dates[0]), new Date(state.datepickerValue.dates[1])]}
                                    isGregorian={state.datepickerValue.isJalali === undefined ? false : state.datepickerValue.isJalali === 'true' ? false : true}
                                    isRange={true}
                                    datepickerParentCallback={handleDatepickerCallback}
                                />
                            </IonCol>
                            <IonCol size="12">
                                <IonLabel>مسافران و کلاس پروازی</IonLabel>
                                <FlightHotelPassenger flightHotelPassengerParentCallback={handlePassengerCallback} itemValue={state.flightHotelPassengerValue} />
                            </IonCol>
                            <IonCol size="12">
                                <IonButton color="warning" expand="block" className="form-submit-button" onClick={onSearchCLick}>
                                    جستجو
                                </IonButton>
                            </IonCol>
                        </IonRow>
                    </div>
                </IonCol>
            </IonRow>
        </IonGrid>
    );
};
export default Flight;